export type { ILabel } from "./interfaces";
export { useGetLabels } from "./useGetLabels";
